// has-permission.directive.ts
import {
    Directive,
    ElementRef,
    HostListener,
    Input,
    NgZone,
    OnInit,
    Renderer2
} from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';

@Directive({
    selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit {
    @Input('hasPermissionModule') module!: string;
    @Input('hasPermissionMode') mode!:string;

    private isAllowed = true;
    private clickBlocker?: (event: Event) => void;
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private zone: NgZone,
        private sharedService: SharedService
    ) { }

    ngOnInit() {
        if (!this.sharedService.assent || !this.mode) return;


        const rule = this.sharedService.getPermissions(this.module);
        this.isAllowed = rule?.[this.mode]?.allowed ?? false;
        // console.log("IsAllowed ==---->",this.isAllowed,rule,this.mode,this.module)
        if (!this.isAllowed) {
            this.applyDisabledState(rule[this.mode]);
            this.blockClicksAtCapturePhase();
        }
    }
    private applyDisabledState(mode) {
        const element = this.el.nativeElement;
        if (mode.action == "hide") {
            this.renderer.setStyle(element, 'visibility', 'hidden');
        } else {
            this.renderer.addClass(element, 'permission-denied');
        }
        // Disable pointer events only if you don't want hover/click at all
        // this.renderer.setStyle(element, 'pointer-events', 'none');
    }

    private blockClicksAtCapturePhase() {
        // This method ensures the event is stopped *before* Angular sees it.
        this.clickBlocker = (event: Event) => {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        };

        this.zone.runOutsideAngular(() => {
            // ✅ Attach in the CAPTURE phase (true)
            this.el.nativeElement.addEventListener('click', this.clickBlocker!, true);
        });
    }
    ngOnDestroy() {
        if (this.clickBlocker) {
            this.el.nativeElement.removeEventListener('click', this.clickBlocker, true);
        }
    }
}
